export enum TeamReviewApprovalSetting {
    AllPass = 0,
    AnyPass = 1,
}